<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.elected.resumedDuringTerm.p1')}}
    {{news.textParams[2]}}
    {{$t('news.template.elected.resumedDuringTerm.p2')}}
    {{news.textParams[3]}}
    {{$t('news.template.elected.resumedDuringTerm.p3')}}
    {{news.textParams[4]}}
  </div>
</template>
